import { makeStyles, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: "green",
    },
    editImage: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    video: {
      width: "90%",
      height: "100%",
    },
    root: {
      height: "80vh",
    },
    center: {
      display: "flex",
      justifyContent: "center",
    },
  })
);
export default useStyles;
